// extracted by mini-css-extract-plugin
export default {"listsCustomer":"ListsServices_listsCustomer__VEEmL","listsServicesButton":"ListsServices_listsServicesButton__5Th-d"};